import React, { useEffect, useState } from 'react';
import { Divider } from 'antd';
import {
 Content,
 Head,
 ConnectName,
 ResourceName,
 FactoryCode,
 FieldName,
 CommentField,
 NumberField,
 DeviceName,
 NumberDevice,
 Text,
 Title,
} from '../../ModalStyled.styled';
import { WarningIcon } from './../../../../_assests';
import moment from 'moment';

interface SelectedMetering {
 daysDifference?: number;
 metering?: any;
}

export default function ConfirmWarning({ connectName, data, meterings }) {
 const checkNumberDevice = data?.filter((item, idx) => {
  return item.summToPaid;
 });

 const [selectedMetering, setSelectedMetering] =
  useState<SelectedMetering>(null);

 useEffect(() => {
  const meteringData = meterings.filter(
   (x: any) => x.meteringDeviceId === data[0].meteringDeviceId,
  );
  if (meteringData && meteringData.length > 0) {
   const dateA = moment(meteringData[0].previousScaleReadingsDate);
   const dateB = moment(new Date());
   const daysBetween = dateB.diff(dateA, 'days');

   const obj: SelectedMetering = {
    daysDifference: daysBetween,
    metering: meteringData[0],
   };

   setSelectedMetering(obj);
  }
 }, []);

 const checkVisibilityColor = () => {
  let obj = {
   visible: true,
   color: '#ffc618',
  };

  return obj;
 };

 const checkValueColor = (consumptionValue) => {
  let obj = {
   visible: true,
   color: '#ffc618',
  };

  return obj;
 };

 return (
  <Content>
   <Head>
    <WarningIcon />
    <Title>Подтвердите ввод показаний</Title>
   </Head>
   <Divider />
   {checkNumberDevice?.map((item) => {
    return (
     <>
      <ConnectName>{connectName}</ConnectName>
      <ResourceName>{item.resourceName}</ResourceName>
      <FactoryCode>
       Заводской номер прибора учета {item.meteringDeviceNumber}
      </FactoryCode>

      <div
       style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        justifyItems: 'center',
       }}
      >
       <FieldName>Расход по переданным показаниям</FieldName>
       <NumberField style={{ color: item?.consumptionLevel }}>
        {item?.consumptionValue} {item?.measureUnit}
       </NumberField>
      </div>

      <FieldName
       style={{
        color: item?.consumptionLevel,
       }}
      >
       {item?.consumptionHint}
      </FieldName>

      <div
       style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        justifyItems: 'center',
       }}
      >
       {item?.estimatedAmount ? (
        <React.Fragment>
         <FieldName>Стоимость* по переданным показаниям</FieldName>
         <NumberField>{item?.estimatedAmount} руб.</NumberField>
        </React.Fragment>
       ) : (
        ''
       )}
      </div>

      {item?.estimatedAmount ? (
       <CommentField>
        *Стоимость ориентировочная без учета потерь по ценам прошлого периода,
        включая НДС
       </CommentField>
      ) : (
       ''
      )}
     </>
    );
   })}
  </Content>
 );
}
